/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

export const environment = {
  production: false,
  disableHttpsCheck: false,
  apiUrl: "https://api.demo.g17.eco",
  oktaClientId: "0oa27h1g7lseKABCH5d7",
  envConfig: {
    stage: "Demo",
    location: "London",
    classname: "demo",
  },
  allowUserPermissions: true,
};
